import { CouponCodeDto } from "src/app/services/api";

export type CouponCodeStatus = "available" | "applied" | "expired";

const EXPIRING_SOON_DAYS = 7;
const DAY_IN_MS = 24 * 60 * 60 * 1000;

// The API sends expiresAt: null for codes that never expire, even though the generated type says string.
const getExpiresAtMs = (code: CouponCodeDto): number => (code.expiresAt ? new Date(code.expiresAt).getTime() : Infinity);

/**
 * Same rule as shopify-extensions: a code is available while it has no transaction and has not expired.
 */
export const getCouponCodeStatus = (code: CouponCodeDto, now: Date = new Date()): CouponCodeStatus => {
  if (code.transactionId) return "applied";

  return getExpiresAtMs(code) > now.getTime() ? "available" : "expired";
};

export const getAvailableCouponCodes = (codes: CouponCodeDto[], now: Date = new Date()): CouponCodeDto[] =>
  codes
    .filter(code => getCouponCodeStatus(code, now) === "available")
    .sort((a, b) => {
      const aExpiresAt = getExpiresAtMs(a);
      const bExpiresAt = getExpiresAtMs(b);
      // Infinity - Infinity is NaN: two codes without expiry keep their order.
      return aExpiresAt === bExpiresAt ? 0 : aExpiresAt - bExpiresAt;
    });

export const isCouponCodeExpiringSoon = (code: CouponCodeDto, now: Date = new Date()): boolean =>
  getExpiresAtMs(code) - now.getTime() <= EXPIRING_SOON_DAYS * DAY_IN_MS;
